import { render, staticRenderFns } from "./TabConclu.vue?vue&type=template&id=68296d61&scoped=true"
import script from "./TabConclu.vue?vue&type=script&lang=ts"
export * from "./TabConclu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68296d61",
  null
  
)

export default component.exports